import React, { useState, useEffect } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import DataTable from "react-data-table-component";
import { ChevronDown, Link } from "react-feather";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import MoveToInboxSharpIcon from "@mui/icons-material/MoveToInboxSharp";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

function AppliedSec(props) {
	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");

	//  // ........................................Job info start..........................

	const [jobInfo, setJobInfo] = useState("");
	console.log("jobInfo", jobInfo);


	const [showInfoModal, setShowInfoModal] = useState(false);
	const handleInfoShow = () => setShowInfoModal(true);
	const handleCloseInfoModal = () => setShowInfoModal(false);

	const JobInfoDate = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetInfo", data).then((resData) => {
				console.log("Info job", resData.data.responseData);
				const data = resData.data.responseData;
				setJobInfo(data);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.warning(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	//  // ........................................Job info End..........................

	// ...............................All Job List Start.......................................
	const userUID = localStorage.getItem("userUID");

	const [page, setPage] = useState(0);
	const [Appliedjob, setAppliedjob] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(0);
	const [search, setSearch] = useState([]);
	const [isError, setIsError] = useState(false);

	const getAppliedJobList = (page) => {
		try {
			const data = {
				sessionId: sessionId,
				pageNumber: page,
				pageSize: 10,
			};

			axios.post(`/Job/GetAppliedJobs`, data).then((response) => {
				const res = response.data.responseData.aplliedJobsList;
				console.log("Applied Job", res);
				setAppliedjob(res);
				setIsLoading(false);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				setIsError(true);
			}
		}
	};
	useEffect(() => {
		getAppliedJobList();
	}, []);
	console.log("Appliedjob", Appliedjob);

	// ...............................All Jobs List End.......................................
	// ................................UnapplyJob Start....................

	const [jobId, setjobId] = useState("");
	const [showAppliedModal, setShowAppliedModal] = useState(false);
	const handleShow = () => setShowAppliedModal(true);
	const handleCloseModal = () => setShowAppliedModal(false);

	const UnapplyJobCandidate = async () => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
		};

		try {
			await axios.post("/JobAction/UnApplyJobAsCnddt", data).then((resData) => {
				console.log("Unapply job", resData.data.message);
				toast.success(resData.data.message);
				setAppliedjob((prev) => prev.filter((item) => item.jobId !== jobId));
				getAppliedJobList();
				setShowAppliedModal(false);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.warning(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	const [jobGroupId, setjobGroupId] = useState("")
	const UnapplyJobInstitute = async () => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
			icsid: jobInfo.grpTypName === 'Class' ? jobInfo.grpTypeId : null,
			icbid: jobInfo.grpTypName === 'Batch' ? jobInfo.grpTypeId : null,
		};
		console.log("data", data);

		try {
			await axios.post("/JobAction/UnApplyJobAsInstt", data).then((resData) => {
				console.log("Unapply job", resData);
				toast.success(resData.data.message);
				setAppliedjob((prev) => prev.filter((item) => item.jobId !== jobId));
				getAppliedJobList();
				setShowAppliedModal(false);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.warning(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	// ........................................UnapplyJob End..........................

	const columns = [
		{
			name: "Job Details",
			center: true,
			sortable: true,
			minWidth: "200px",
			cell: (row) => (
				<div
					className="text-center"
					style={{ display: "flex", flexDirection: "column", gap: "5px" }}
				>
					<div>
						<div className="pointer jobinfo f-600">
							<a href={`/jobDetails/${row.jobId}`}>{row.title}</a>
						</div>
					</div>
					<div className="pointer">{row.shortDescription}</div>
					<div className="pointer">
						{moment(row.creationTime).format("DD  MMM YYYY")}
					</div>
				</div>
			),
		},

		{
			name: "Company Name",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.compName,
		},
		{
			name: "Designation",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.designationName,
		},
		{
			name: "Status",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => (
				// row.hiringStatusName,
				<>
					<div className="job-foote p-3">
						<ul className="p-0">
							<li>
								<a href="/#">{row.hiringStatusName}</a>
							</li>
						</ul>
					</div>
				</>
			),
		},
		{
			name: "Action",
			center: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					<span className="me-2">
						<Tooltip title="Withdraw" arrow>
							<MoveToInboxSharpIcon
								className="pointer"
								onClick={() => {
									handleShow();
									setjobId(row.jobId);
									JobInfoDate(row.jbApplctnId)
									// {
									// 	console.log("===>", row, jobInfo);
									// }
									// setjobGroupId(jobInfo.grpTypeId);
								}}
							/>
						</Tooltip>
					</span>

					<span>
						<Tooltip title="Info" arrow>
							<VisibilitySharpIcon
								onClick={() => {
									handleInfoShow();
									JobInfoDate(row.jbApplctnId);
								}}
								className="pointer"
							/>
						</Tooltip>
					</span>
				</>
			),
		},
	];

	const handlePageChange = (pageNumber) => {
		setPage(pageNumber - 1);
		getAppliedJobList(pageNumber - 1);
	};

	return (
		<>
			<section className="pricing-section-three container jobapplication Appliedjob pt-5">
				<div className="mt-2">
					<h6 className="orange-title">
						<span className="orange-box me-2"></span>
						{props.title}{" "}
					</h6>
				</div>
				<div className="container st3">
					<div className="row">
						<div className="col-lg-12">
							{isError ? (
								console.log("Data not found")
							) : (
								<div className="scroll-react-dataTable">

									<div className="react-dataTable">
										<DataTable
											noHeader
											pagination
											columns={columns}
											paginationPerPage={7}
											className="react-dataTable"
											sortIcon={<ChevronDown size={10} />}
											paginationDefaultPage={currentPage + 1}
											data={Appliedjob}
											onChangePage={handlePageChange}
										/>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</section>

			{/*.................................... UnApply Job Modal Start ................................*/}

			<Modal show={showAppliedModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title> UnApply Job</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to UnApply Job</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button

						onClick={() => {
							if (UserType === "Candidate") {
								UnapplyJobCandidate();
							} else {
								UnapplyJobInstitute();
							}

						}}

						className="btn btn-danger me-2"
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>
			{/*.................................... UnApply Job Modal End ................................*/}

			{/*.................................... Info Job Modal Start ................................*/}

			<Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
				<Modal.Header>
					<Modal.Title> Job Info</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						{jobInfo.grpName === "" ? (
							""
						) : (
							<p>
								<span className="f-600">Group Name : </span> {jobInfo.grpName}
							</p>
						)}
						{jobInfo.grpTypName === "" ? (
							" "
						) : (
							<p>
								<span className="f-600">Group Type Name : </span>{" "}
								{jobInfo.grpTypName}
							</p>
						)}
						{jobInfo.hiringStatusName === "" ? (
							" "
						) : (
							<p>
								<span className="f-600">Hiring Status Name : </span>{" "}
								{jobInfo.hiringStatusName}
							</p>
						)}
						{jobInfo.rateTypeName === "" ? (
							" "
						) : (
							<p>
								<span className="f-600">Rate Type Name : </span>{" "}
								{jobInfo.rateTypeName}
							</p>
						)}
						{jobInfo.typeName === "" ? (
							" "
						) : (
							<p>
								<span className="f-600">Type Name :</span> {jobInfo.typeName}
							</p>
						)}
					</div>
				</Modal.Body>
			</Modal>
			{/*.................................... Info Job Modal End ................................*/}
		</>
	);
}

export default AppliedSec;
